<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="loadingTable"
      >
        <loading />
      </div>

      <!-- dataTable y botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>
        <!-- Botones -->
        <div
          class="d-flex"
          style="position: absolute"
          :style="[zIndexModal && { 'z-index': '0' }]"
        >
          <actualizar-booking-por-aceptar
            :idBooking="idBooking"
            :idByCountry="idByCountry"
            :load="load"
          />
          <informacion-general-modal
            :data="dataInformacionGeneral"
            :dataVer="dataVer"
            :load="load"
          />
          <filtro-ver-bookings-por-aceptar class="mb-3" />
        </div>

        <!-- Data Table -->
        <data-table
          customHeaders
          :headers="headers"
          :data="dataAux"
          :acciones="acciones"
          :max="8"
          paginacion
          buscar
          idtabla="ver_mis_booking_por_aceptar"
          :seleccionar="obtenerFilaSeleccionada"
          numerador
          exportarExcel
        />
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
// Vue
import Vue from "vue";
// Toast
import VueToastify from "vue-toastify";

Vue.use(VueToastify);
// Componentes
import DataTable from "../../../components/common/DataTable";
import Loading from "../../common/loading";
import FiltroVerBookingsPorAceptar from "../../filtros/lineas/booking/FiltroVerBookingsPorAceptar";
import InformacionGeneralModal from "../../modals/lineas/booking/bookings_por_aceptar/InformacionGeneralModal";
import ActualizarBookingPorAceptar from "../../modals/lineas/booking/bookings_por_aceptar/ActualizarBookingPorAceptar";
// Constantes
import {
  getVerMisBookingsPorAceptar,
  deleteBookingsPorAceptar,
  verBooking,
  sendEmailsContactosClientesPorBookingId, getVerMisBookingsPorAceptarFiltrados
} from "../../../constants/lineas";

export default {
  props: ["data"],
  computed: {
    ...mapState([
      "loading",
      "loadingTable",
      "isAdmin",
      "usuarioActual",
      "zIndexModal",
    ]),
    ...mapState("lineas", [
      "flagFiltersBookings",
      "currentFiltersBookings"
    ]),
  },
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        { title: "ID", width: "30px" },
        { title: "Año", width: "30px" },
        { title: "Semana", width: "30px" },
        { title: "Cliente", width: "35px" },
        { title: "Shipper", width: "35px" },
        { title: "POD", width: "60px" },
        { title: "Consignatario", width: "60px" },
        { title: "Cantidad", width: "60px" },
        { title: "Producto", width: "60px" },
        { title: "Planificado", width: "60px" },
        { title: "Genset Naviera", width: "60px" },
        { title: "Comentario", width: "60px" },
        { title: "Acciones", width: "40px" },
      ],
      acciones: [],
      dataInformacionGeneral: [],
      dataAux: this.data,
      dataActualizarPorAceptar: [],
      dataVer: [],
      load: false,
      idBooking   : null ,
      idByCountry : "" ,
    };
  },
  components: {
    DataTable,
    FiltroVerBookingsPorAceptar,
    Loading,
    InformacionGeneralModal,
    ActualizarBookingPorAceptar,
  },
  methods: {
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable",
      "ActionSetVisibleModalBL",
    ]),
    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneral",
      "actionSetDatatableVerMisBookingsPorAceptar",
      "actionSetStateIdDeclarados"
    ]),
    ...mapActions(["ActionSetVisibleModalEditarBookingPorAceptar"]),

    async generarBotonesAcciones() {
      let me = this;

      await me.dataAux.map((item, index) => {
        me.acciones.push([
          {
            icon: "fa fa-search #66BB6A",
            title: "Ver Booking",
            id: index,
          },
          {
            icon: "fa fa-edit",
            title: "Editar Booking",
            id: index,
          },
          {
            icon: "far fa-envelope",
            title: "Enviar Booking a email",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar Booking",
            id: index,
          },
        ]);
      });

      me.ActionSetLoadingTable(false);
    },

    async obtenerFilaSeleccionada(fila) {
      let data_fila = this.data[fila.id];
      let id_booking = data_fila.data_complementaria[0];
      let nombre_cliente = data_fila.data[3];

      if (fila.accion === "Ver Booking") {
        this.load = true;
        this.actionSetVisibleModalInformacionGeneral(true);
        this.dataInformacionGeneral = data_fila;
        await this.cargarVerBooking(id_booking);
        this.load = false;
      } else if (fila.accion === "Editar Booking") {
        
        this.idBooking   = id_booking ;
        this.idByCountry = data_fila.data[0] + "" ;

        this.actionSetStateIdDeclarados( id_booking );


        this.ActionSetVisibleModalEditarBookingPorAceptar(true);

      } else if (fila.accion === "Eliminar Booking") {

        this.$vToastify.prompt({
            body: `¿Desea eliminar el Booking por Aceptar: ${id_booking} de ${nombre_cliente}?`,
            answers: { Sí: true, No: false },
        }).then((respuesta) => respuesta && this.eliminarBookingPorAceptar(id_booking));

      } else if (fila.accion === "Enviar Booking a email") {
        
        const response = await this.$vToastify.prompt({ body: `¿Desea enviar Booking a Email?`, answers: { Sí: true, No: false }}) ;
        if( !response ) return ;

        try {
          this.$vToastify.loader("Realizando Solicitud...");
          await sendEmailsContactosClientesPorBookingId( id_booking , "porAceptar" ) ;

          this.$vToastify.stopLoader();
          this.$vToastify.success("Booking enviado a emails correctamente", "¡Realizado!" );

        } catch (error) {
          this.$vToastify.stopLoader();
          this.$vToastify.error( "Error al enviar booking por email, intente más tarde", "¡Error!" );
        }
      }
    },

    async cargarVerBooking(id_booking) {
      const data = await verBooking(id_booking);
      this.dataVer = data;
    },

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async eliminarBookingPorAceptar(id) {

      let sql = await deleteBookingsPorAceptar({ id });

      if (!sql.error) {

        if (this.flagFiltersBookings) {

          const data = await getVerMisBookingsPorAceptarFiltrados(this.currentFiltersBookings);

          this.actionSetDatatableVerMisBookingsPorAceptar(data);

          this.dataAux = data;

        } else {

          let dataPorAceptar = await getVerMisBookingsPorAceptar();

          this.actionSetDatatableVerMisBookingsPorAceptar( dataPorAceptar.data_table);

          this.dataAux = dataPorAceptar.data_table;

        }

        await this.generarBotonesAcciones();

        this.$vToastify.success(
          "Booking por Aceptar eliminado correctamente",
          "¡Realizado!"
        );
      } else {
        console.log("Error");
      }
    },
  },
  watch: {
    data: function (_new) {
      let me = this;

      if (_new) {
        me.dataAux = _new;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
